import { getOperationName } from '@apollo/client/utilities';
import { ACTIVATE_AND_UPDATE_USER, FORGOT_PASSWORD, LOGIN, RESET_PASSWORD } from './mutation/users';

// titan validates any token it receives before running the operation, so an expired one fails
// even operations that need no session
const SESSIONLESS_OPERATIONS = new Set(
  [LOGIN, FORGOT_PASSWORD, RESET_PASSWORD, ACTIVATE_AND_UPDATE_USER].map(getOperationName)
);

export const isSessionlessOperation = (operationName?: string) =>
  !!operationName && SESSIONLESS_OPERATIONS.has(operationName);
